// src/admin/components/ShippingTable.jsx
import React from "react";
import { FaPen, FaTrash } from "react-icons/fa";

const ShippingTable = ({ fees, onEdit, onDelete, canWrite = true }) => {

  // ensure we always work with an array
  const safeFees = Array.isArray(fees) ? fees : [];

  if (safeFees.length === 0) {
    return (
      <div className="no-variants-message">
        <p>No shipping fees available.</p>
      </div>
    );
  }

  return (
    <div className="luxury-table-container">
      <table className="luxury-table">
        <thead>
          <tr>
            <th>State</th>
            <th>Combo Fee</th>
            <th>Delivery Fee</th>
            <th>Above ₹500 Fee</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {safeFees.map((f) => (
            <tr key={f.id ?? f._id ?? Math.random()}>
              <td style={{ fontWeight: "700", color: "#181c32" }}>{f.state ?? "—"}</td>
              <td>₹{f.combo_fee ?? "—"}</td>
              <td>₹{f.delivery_fee ?? "—"}</td>
              <td>₹{f.above_500_fee ?? "—"}</td>
              <td>
                <div className="table-actions">
                  {canWrite && (
                    <>
                      <button className="action-btn edit" onClick={() => onEdit(f)} title="Edit">
                        <FaPen />
                      </button>
                      <button className="action-btn delete" onClick={() => onDelete(f._id || f.id)} title="Delete">
                        <FaTrash />
                      </button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShippingTable;
